document.addEventListener("turbo:load", function() {
  if ($("#login").length > 0) {
    
  }
});
    